module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc1-05-1348c594f3b3985515c683d9e9577e69.png";